var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1460,
    transform: "translate(-1349 -435)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-841.5 -224.5H63.5V673C63.5 678.247 59.2467 682.5 54 682.5H-832C-837.247 682.5 -841.5 678.247 -841.5 673V-224.5Z",
    stroke: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8228 2V1.05263C14.8228 0.471279 14.4217 0 13.9269 0H4.07171C3.5769 0 3.17578 0.471279 3.17578 1.05263V2H2.11765C0.948103 2 0 2.9481 0 4.11765V17.8824C0 19.0519 0.948103 20 2.11765 20H15.8824C17.0519 20 18 19.0519 18 17.8824V4.11765C18 2.9481 17.0519 2 15.8824 2H14.8228ZM13.9269 1.05263H4.07171V2H13.9269V1.05263Z",
    fill: "#FF8000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 4,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 4,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 4,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 4,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 4,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 4,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 4,
    width: 4,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 4,
    height: 4,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1460,
    fill: "white",
    transform: "translate(-1349 -435)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.80d386aa6df03445f1a5e46b719a10df.svg";
export { ForwardRef as ReactComponent };